module.exports = __webpack_public_path__ + "static/media/farmdokMockAppleMobileApplicationFR.58e7a3e7.png";